/* GUYA research: SSR SVG/data tables remain readable without JavaScript. */
(() => {
  if (window.guyaResearchReady) return;
  window.guyaResearchReady = true;
  const initialized = new WeakSet();
  const observed = new Map();
  function init(scope = document) {
    scope.querySelectorAll('[data-guya-chart]').forEach(chart => {
      if (initialized.has(chart)) return;
      initialized.add(chart);
      const output = chart.querySelector('[data-guya-readout]');
      const points = [...chart.querySelectorAll('[data-guya-point]')];
      const seriesButtons = [...chart.querySelectorAll('[data-guya-series]')];
      const resetSeries = () => {
        chart.querySelectorAll('svg .is-muted').forEach(el => el.classList.remove('is-muted'));
        seriesButtons.forEach(button => button.setAttribute('aria-pressed', 'false'));
      };
      const show = point => {
        points.forEach(p => p.classList.toggle('is-active', p === point));
        output.textContent = point.dataset.summary;
      };
      points.forEach((point, index) => {
        point.addEventListener('pointerenter', () => show(point));
        point.addEventListener('focus', () => { if (point.classList.contains('is-muted')) resetSeries(); show(point); });
        point.addEventListener('click', () => show(point));
        point.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); show(point);
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            points[(index + (event.key === 'ArrowRight' ? 1 : -1) + points.length) % points.length].focus();
          }
        });
      });
      // Closely spaced series share large touch targets. Resolve by the nearest
      // actual marker, not SVG paint order, so the last series cannot steal hover.
      const plot = chart.querySelector('svg');
      const showNearest = event => {
        if (!Number.isFinite(event.clientX) || !Number.isFinite(event.clientY)) return;
        let nearest = null;
        let distance = 42;
        points.forEach(point => {
          if (point.classList.contains('is-muted')) return;
          const dot = point.querySelector('.guya-chart__dot');
          if (!dot) return;
          const box = dot.getBoundingClientRect();
          const delta = Math.hypot(event.clientX - box.x - box.width / 2, event.clientY - box.y - box.height / 2);
          if (delta < distance) { nearest = point; distance = delta; }
        });
        if (nearest) show(nearest);
      };
      plot.addEventListener('pointermove', showNearest);
      plot.addEventListener('click', showNearest);
      seriesButtons.forEach(button => {
        button.disabled = false;
        button.addEventListener('click', () => {
          const wasSelected = button.getAttribute('aria-pressed') === 'true';
          resetSeries();
          if (wasSelected) return;
          button.setAttribute('aria-pressed', 'true');
          const selectedClass = 'guya-chart__series-' + button.dataset.guyaSeries;
          chart.querySelectorAll('svg .guya-chart__line, svg .guya-chart__point').forEach(el => {
            el.classList.toggle('is-muted', !el.classList.contains(selectedClass));
          });
          const point = points.find(p => p.classList.contains(selectedClass));
          if (point) show(point);
        });
      });
      const replay = chart.querySelector('[data-guya-chart-replay]');
      replay.hidden = false;
      replay.addEventListener('click', () => {
        chart.classList.remove('is-visible');
        // Restart only the short entry animation, never the measurements themselves.
        void chart.offsetWidth;
        chart.classList.add('is-visible');
      });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) {
            chart.classList.add('is-visible');
            observer.disconnect(); observed.delete(chart);
          }
        }, {threshold: 0.12});
        observed.set(chart, observer); observer.observe(chart);
      } else chart.classList.add('is-visible');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observed.forEach((observer, chart) => {
      if (event.target.contains(chart)) { observer.disconnect(); observed.delete(chart); }
    });
  });
})();
